/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CertificateChainItem } from './CertificateChainItem';
import {
    CertificateChainItemFromJSON,
    CertificateChainItemFromJSONTyped,
    CertificateChainItemToJSON,
} from './CertificateChainItem';

/**
 * Related campaign credential
 * @export
 * @interface CampaignCredentialDetailedDto
 */
export interface CampaignCredentialDetailedDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof CampaignCredentialDetailedDto
     */
    said?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCredentialDetailedDto
     */
    type?: CampaignCredentialDetailedDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignCredentialDetailedDto
     */
    status?: CampaignCredentialDetailedDtoStatusEnum;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof CampaignCredentialDetailedDto
     */
    issueeAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CampaignCredentialDetailedDto
     */
    issueeAlias?: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof CampaignCredentialDetailedDto
     */
    issuerAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CampaignCredentialDetailedDto
     */
    issuerAlias?: string;
    /**
     * When the credential was issued in format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof CampaignCredentialDetailedDto
     */
    issuedAt?: string;
    /**
     * When the credential was revoked if it was revoked. Format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof CampaignCredentialDetailedDto
     */
    revokedAt?: string;
    /**
     * 
     * @type {Array<CertificateChainItem>}
     * @memberof CampaignCredentialDetailedDto
     */
    certificateChain?: Array<CertificateChainItem>;
    /**
     * Phone numbers in TN and Campaign credentials
     * @type {object}
     * @memberof CampaignCredentialDetailedDto
     */
    phoneNumbers?: object;
}


/**
 * @export
 */
export const CampaignCredentialDetailedDtoTypeEnum = {
    Unknown: 'UNKNOWN',
    Dossier: 'DOSSIER',
    OrgIdentity: 'ORG_IDENTITY',
    Range: 'RANGE',
    Brand: 'BRAND',
    TnAlloc: 'TN_ALLOC',
    DelSig: 'DEL_SIG',
    Qvi: 'QVI',
    Root: 'ROOT',
    A2PCampaign: 'A2P_CAMPAIGN'
} as const;
export type CampaignCredentialDetailedDtoTypeEnum = typeof CampaignCredentialDetailedDtoTypeEnum[keyof typeof CampaignCredentialDetailedDtoTypeEnum];

/**
 * @export
 */
export const CampaignCredentialDetailedDtoStatusEnum = {
    Active: 'ACTIVE',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED'
} as const;
export type CampaignCredentialDetailedDtoStatusEnum = typeof CampaignCredentialDetailedDtoStatusEnum[keyof typeof CampaignCredentialDetailedDtoStatusEnum];


/**
 * Check if a given object implements the CampaignCredentialDetailedDto interface.
 */
export function instanceOfCampaignCredentialDetailedDto(value: object): boolean {
    return true;
}

export function CampaignCredentialDetailedDtoFromJSON(json: any): CampaignCredentialDetailedDto {
    return CampaignCredentialDetailedDtoFromJSONTyped(json, false);
}

export function CampaignCredentialDetailedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignCredentialDetailedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'issueeAlias': json['issueeAlias'] == null ? undefined : json['issueeAlias'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'issuerAlias': json['issuerAlias'] == null ? undefined : json['issuerAlias'],
        'issuedAt': json['issuedAt'] == null ? undefined : json['issuedAt'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'certificateChain': json['certificateChain'] == null ? undefined : ((json['certificateChain'] as Array<any>).map(CertificateChainItemFromJSON)),
        'phoneNumbers': json['phoneNumbers'] == null ? undefined : json['phoneNumbers'],
    };
}

export function CampaignCredentialDetailedDtoToJSON(value?: CampaignCredentialDetailedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'type': value['type'],
        'status': value['status'],
        'issueeAid': value['issueeAid'],
        'issueeAlias': value['issueeAlias'],
        'issuerAid': value['issuerAid'],
        'issuerAlias': value['issuerAlias'],
        'issuedAt': value['issuedAt'],
        'revokedAt': value['revokedAt'],
        'certificateChain': value['certificateChain'] == null ? undefined : ((value['certificateChain'] as Array<any>).map(CertificateChainItemToJSON)),
        'phoneNumbers': value['phoneNumbers'],
    };
}

